import { Trans } from 'react-i18next';

import { StrongText } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { magistralDrugTemplatesTranslationKeys } from '../../../../translations';

import { MagistralDrugTemplateListItem } from './MagistralDrugTemplates.types';

type MagistralDrugTemplatesUseTemplateModalConfirmButtonProps = {
   readonly shouldConfirm: boolean;
   readonly onClick: (template: MagistralDrugTemplateListItem) => void;
};

export const MagistralDrugTemplatesUseTemplateModalConfirmButton = (
   props: MagistralDrugTemplatesUseTemplateModalConfirmButtonProps
): JSX.Element => {
   return (
      <FormsTemplates.UseTemplateModalConfirmButton<MagistralDrugTemplateListItem>
         onClick={props.onClick}
         confirmationText={
            props.shouldConfirm ? (
               <Trans
                  i18nKey={magistralDrugTemplatesTranslationKeys.areYouSureUsingTemplate}
                  components={{ strong: <StrongText testId={'useTemplate'} /> }}
               />
            ) : undefined
         }
         successMessage={magistralDrugTemplatesTranslationKeys.templateUsed}
      />
   );
};
